<template>
  <div>
    <div id="container-table">
      <ts-loading-banner :loading="waiting">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('invoice.feeGroupName') }}</th>
              <th>{{ $t('invoice.paymentTerm') }}</th>
              <th style="width: 16%;" class="text-center">
                {{ $t('invoice.amount') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(resource, index) in resources"
              :key="index"
              @dblclick="pickFee(resource)"
            >
              <td>{{ resource.fee_group_name }}</td>
              <td>{{ resource.payment_term }}</td>
              <td class="text-center">{{ resource.fee_amount }}</td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'feeGroupList',
  props: ['isActive', 'gradeId'],
  data() {
    return {
      resources: [],
      waiting: false
    }
  },
  methods: {
    ...mapActions('invoice', ['getFeeGroup']),
    fetchData() {
      this.waiting = true
      this.resources = []
      this.getFeeGroup(this.gradeId)
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    pickFee(feeGroup) {
      this.$emit('seleted', parseInt(feeGroup.fee_group_id))
    }
  },
  watch: {
    gradeId: function(id) {
      if (this.isActive == 2) {
        this.fetchData()
      }
    }
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 35vh;
  height: 30vh;
}
.table > thead > tr > th {
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  cursor: pointer;
  font-size: 12px !important;
}
</style>
